import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "stores/connect";
import InputThroughput from "./InputThroughput";
import ForwarderInputStatesStore from "../stores/ForwarderInputStatesStore";
const ForwarderInputThroughput = ({ forwarder, input }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { forwarderInputStates: states } = useStore(ForwarderInputStatesStore);
  const currentInputMetric = useMemo(() => {
    var _a, _b;
    const statesByInput = (states || []).filter((state) => state.input_id === input.id);
    if (!forwarder) {
      return null;
    }
    return (_b = (_a = statesByInput.filter((state) => state.forwarder_id === forwarder.id)[0]) == null ? void 0 : _a.metrics) == null ? void 0 : _b.filter((metric) => metric.name === "incomingMessages");
  }, [input, forwarder, states]);
  const hasResults = currentInputMetric && currentInputMetric.length > 0;
  if (!hasResults) {
    return /* @__PURE__ */ React.createElement("dd", null, t("common.no_metrics"));
  }
  return /* @__PURE__ */ React.createElement(InputThroughput, { metrics: currentInputMetric[0] });
};
export default ForwarderInputThroughput;
